import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostReactionParticipantsKey } from '../../utils/keys';
export const usePostReactionParticipants = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const postReactionParticipantsKey = getPostReactionParticipantsKey({
        variables,
        fields,
    });
    return useInfiniteQuery(postReactionParticipantsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.posts.reactionParticipants({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=usePostReactionParticipants.js.map